import { render, staticRenderFns } from "./ListTransactionDetails.vue?vue&type=template&id=4325994d&"
import script from "./ListTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./ListTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports